var disposed = false
function injectStyle (context) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true,\"url\":false}!../../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-2299230a\",\"scoped\":true,\"sourceMap\":true}!./map-right-click.css")
}
/* script */
export * from "!!babel-loader!./map-right-click.js"
import __vue_script__ from "!!babel-loader!./map-right-click.js"/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2299230a\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/selector?type=template&index=0!./MapRightClick.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2299230a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/fragments/map-view/components/map-right-click/MapRightClick.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2299230a", Component.options)
  } else {
    hotAPI.reload("data-v-2299230a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports
